import { SecondaryButton } from "@acko-tech/building-blocks.ui.button";
import { Box } from "@acko-tech/building-blocks.ui.common";
import styled from "styled-components";
import { Text } from "@acko-tech/building-blocks.ui.typography";
export const StyledInput = styled.input`
  box-sizing: border-box;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  color: #040222;
  width: calc(100% - 22px);
  border-radius: 10px;
  background: #ffffff;
  padding: 13px 12px;
  font-size: 1rem;
  line-height: 16px;
  outline: none;
  border: none;
  ::placeholder {
    color: #5b5675;
    font-family: 'Euclid Circular B', 'Inter', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
  @media (max-width: 786px) {
    // padding: 4px;
  }
`;

export const FieldButton = styled(SecondaryButton)`
  height: 44px;
  background: none;
  @media (max-width: 786px) {
    height: 40px;
    padding: 8px 16px;
  }
`;

export const FieldButtonWrapper = styled(Box)`
  position: absolute;
  right: 4px;
  top: 8px;
  width: auto;
  height: 40px;
  @media (max-width: 786px) {
    width: 88px;
    right: 4px;
  }
`;

export const ApplyBtn = styled.div`
  position: absolute;
  right: 1rem;
  top: 12px;
  width: auto;
  cursor: pointer;
  color: #1b73e8;
`;

export const ErrorText = styled(Text)`
  color: #d83d37;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px; 
`;
